
import { Box, FormControl, InputLabel } from '@mui/material';
import * as React from 'react';
import Log from '@/Logger';
import { type DeviceInfo, useDeviceList } from '@/hooks/useDeviceList';
import ItemSelectDropDown from '../util/ItemSerlectDoropDown/ItemSelectDropDown';

export type DeviceListProps = {};

export type DeviceListHandle = {
    selectedDevices: DeviceInfo[];
};

const DeviceList = React.forwardRef<DeviceListHandle, DeviceListProps>((_, ref) => {
    const { deviceList, isLoading } = useDeviceList();
    const [selectedDevices, setSelectedDevices] = React.useState<DeviceInfo[]>([]);

    React.useImperativeHandle(ref, () => ({
        selectedDevices,
    }), [selectedDevices]);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const DEVICE_LIST_WIDTH = 344;
    const MenuProps = {
        anchorOrigin: { vertical: "bottom", horizontal: "left" }, // ポップオーバーの表示起点
        transformOrigin: { vertical: "top", horizontal: "left" }, // 表示時の transform の起点
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
                width: DEVICE_LIST_WIDTH,
                overflowX: 'auto' as const, // 横スクロールを有効にする
            },
        },
    };

    return (
        <Box sx={{ minWidth: 120 }}>
            <FormControl data-testid="device-list" sx={{ minWidth: 223 }}>
                <InputLabel
                    id="demo-simple-select-label"
                    sx={{ backgroundColor: 'white' }}
                >
                    デバイス名
                </InputLabel>
                <ItemSelectDropDown
                    data={deviceList.map(device => (device.name))}
                    selectedValues={selectedDevices.map(d => d.name)}
                    onChange={(value) => {
                        const logger = Log.getLogger();
                        logger.ui.info('DeviceList', 'DeviceSelectDropDown onChange');
                        setSelectedDevices(deviceList.filter(d => value.includes(d.name)));
                    }}
                    width={DEVICE_LIST_WIDTH}
                    variant="outlined"
                    renderValue={(selected) => {
                        return selected.join(', ');
                    }}
                    MenuProps={MenuProps}
                    disabled={isLoading}

                />
            </FormControl>
        </Box>
    );
});

export default DeviceList;
